
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import Dator from "@/utils/censor.js";
import loginFun from "@/utils/cc-webapp/login.js";
import newPopup from "@/components/popup/popup";
import Vue from "vue";
import { log } from "util";
import { Toast } from "vant";
import { SERVER } from "../../api/apiConfig";

export default {
name: "login",
components: {
XInput,
Group,
Picker,
Popup,
Cell,
newPopup,
},

data() {
return {

appleIcon: false, //ios登录按钮
newPopFlag: false, //隐私条款弹窗
ruleFlag: true, //是否同意隐私条款
msgFlag: true, //是否推送
isHmsAvailable: false,
huaweiClass: "huawei_logo img_auto",
googleClass: "google_logo img_auto",
iconNone: require("@/assets/image/icon/dele.png"),
iconAll: {
iconLogo: require("@/assets/image/icon/logo.png"),
wechatLogo: require("@/assets/image/icon/wechat_logo.png"),
facebookLogo: require("@/assets/image/icon/facebook_logo.png"),
googleLogo: require("@/assets/image/icon/googlePay.png"),
appleLogo: require("@/assets/image/icon/apple_logo.png"),
huaweiLogo: require("@/assets/image/icon/hw_logo.png"),
arrow: require("@/assets/image/icon/arrow.png"),
},
area: [
[
{ name: this.$t("LOGIN_LANG.area.0"), value: "+86" },
{ name: this.$t("LOGIN_LANG.area.1"), value: "+852" },
{ name: this.$t("LOGIN_LANG.area.2"), value: "+853" },
],
],
selectArea: ["+852"], //選擇器默認選擇
phoneArea: "+852", //頁面顯示
popupFlag: false, //區域號碼選擇彈窗
showType: false, //true電郵登入  false手機登入,
phoneNum: "",
second: 0,
code: "",
passw: "",
email: "",
isNative: false,

returnTarget: null,
loginFag: true, //限制点击登录次数
bindThirdShow: false, //选择绑定手机还是邮箱
session: "",
userInfo: "",
preRouter: "", //記錄上一頁路由
nextUrl: "",
authList: ["mylink", "orangenews"],
showAuthView: false,
};
},

methods: {

onClickLeft() {
this.$router.go(-1);
},
changeRule() {
this.ruleFlag = !this.ruleFlag;
},
changeMsg() {
this.msgFlag = !this.msgFlag;
},
showNewPopup() {
this.newPopFlag = true;
},
newPopOpen() {

},
newPopClose(type = false) {
this.newPopFlag = false;
if (type) {
this.ruleFlag = true;
}

},

openToBind(res, preRouter) {
let obj = {};
obj["path"] = res;
obj["query"] = {
getPage: true,
session: this.session,
userInfo: this.userInfo,
};


setTimeout(() => {
this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
}, 500);
},

openToRegistSuccess(showToast) {
let obj = {};
obj["path"] = "/app/registerSuccess";
this.$toast.text(showToast);

setTimeout(() => {
this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
}, 1500);
},


showArea() {
this.popupFlag = !this.popupFlag;
},

changeArea() {
this.popupFlag = !this.popupFlag;
this.phoneArea = this.selectArea[0];
},

changeShowType() {
this.showType = !this.showType;
},
goFindPassword() {
let obj = {
path: "forget",
};
this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
},

getTelVerificationCode() {
if (this.second > 0) {

return;
}

let loginCode = localStorage.getItem("loginCode");

if (loginCode == "" || loginCode == undefined) {

} else {


let obj = JSON.parse(loginCode);
if (
obj.iphone == this.phoneNum &&
obj.time + 60000 > new Date().getTime()
) {

let second = (obj.time + 60000 - new Date().getTime()) / 1000;
this.second = Math.ceil(second);
this.startCounting();
this.$toast.text(this.$t("LOGIN_LANG.soFast"));
return;
}
}


let dator = new Dator.dator();
dator.add(this.phoneNum, [
{ strategy: "isEmpty", errMsg: this.$t("LOGIN_LANG.phoneNull") },
]);

if (this.phoneArea === "+852" || this.phoneNum === "+853") {

dator.add(this.phoneNum, [
{ strategy: "checkNumber", errMsg: this.$t("LOGIN_LANG.phoneErr") },
{
strategy: "checkStringFormat:8:1",
errMsg: this.$t("LOGIN_LANG.phoneErr"),
},
]);
}

if (this.phoneArea === "+86") {

dator.add(this.phoneNum, [
{
strategy: "checkStringFormat:11:1",
errMsg: this.$t("LOGIN_LANG.phoneErr"),
},
{ strategy: "checkPhone", errMsg: this.$t("LOGIN_LANG.phoneErr") },
]);
}

if (dator.getErrmsg()) {
this.$toast.text(dator.getErrmsg());
return;
}

let postD = {
area: this.phoneArea,
phone: this.phoneNum,
type: 0,
};
console.log("postD", postD);
this.second = 60;
this.GLOBAL_.ccRequest
.doAxios(this.CONFIG.USER.TELVERIFICATIONCODE, postD, "POST")
.then((res) => {

console.log("res", res);
this.startCounting();
this.$toast.text(this.$t("LOGIN_LANG.sendCodeSuccess"));

var test = {
key: "loginCode",
value: JSON.stringify({
time: new Date().getTime(),
iphone: this.phoneNum,
}),
};
localStorage.setItem(JSON.stringify(test));
})
.catch((err) => {


});
},
startCounting() {
let _this = this;
if (this.second > 0) {
setTimeout(() => {
_this.second -= 1;
_this.startCounting();
}, 1000);
}
},
doLogin() {
if (!this.ruleFlag) {
return this.$toast.text(this.$t("LOGIN_LANG.newUserSeeToast"));
}

if (!this.loginFag) {
this.$toast.text("操作频繁");
return;
}

if (this.showType) {

this.emailLogin();
} else {

this.telLogin();
}
},

telLogin() {
let dator = new Dator.dator();

if (this.phoneArea === "+852" || this.phoneNum === "+853") {

dator.add(this.phoneNum, [
{ strategy: "checkNumber", errMsg: this.$t("LOGIN_LANG.phoneErr") },
{
strategy: "checkStringFormat:8:1",
errMsg: this.$t("LOGIN_LANG.phoneErr"),
},
]);
}

if (this.phoneArea === "+86") {

dator.add(this.phoneNum, [
{
strategy: "checkStringFormat:11:1",
errMsg: this.$t("LOGIN_LANG.phoneErr"),
},
{ strategy: "checkPhone", errMsg: this.$t("LOGIN_LANG.phoneErr") },
]);
}

dator.add(this.code, [
{ strategy: "isEmpty", errMsg: this.$t("LOGIN_LANG.inputCode") },
{
strategy: "checkStringFormat:4:1",
errMsg: this.$t("LOGIN_LANG.codeErr"),
},
]);

if (dator.getErrmsg()) {
this.$toast.text(dator.getErrmsg());
return;
}

let postD = {
area: this.phoneArea,
phone: this.phoneNum,
code: this.code,
};

this.$toast.loading();
this.loginFag = false;

this.GLOBAL_.ccRequest
.doAxios(this.CONFIG.USER.TELLOGIN, postD, "POST")
.then((res) => {

console.log("res", res);
if (res.data) {
this.$toast.close();

this.saveLoginSession(res);
} else {
this.$toast.text(this.$t("REQUEST_ERR_LANG_5"));
}
})
.catch((err) => {
console.log("err", err);
this.loginFag = true;
this.$toast.close();

let res = err.response;
this.$toast.text(
this.$t("LOGIN_LANG.loginErr") + ":" + res.data.message
);
});
},

saveLoginSession(res) {
let obj = res.data.session;
obj["userInfo"] = res.data.userInfo;

loginFun.saveLoginSession(obj);
if (this.nextUrl) {
setTimeout(() => {
window.location.href = this.nextUrl;
}, 500);
} else {
setTimeout(() => {
this.$router.back();
}, 500);
}
},


emailLogin() {

let dator = new Dator.dator();
dator.add(this.email, [
{ strategy: "isEmpty", errMsg: this.$t("LOGIN_LANG.emailNullErr") },
{ strategy: "checkEmail", errMsg: this.$t("LOGIN_LANG.emailErr") },
]);

if (dator.getErrmsg()) {
Toast(dator.getErrmsg());
return;
}


let dator2 = new Dator.dator();
dator2.add(this.passw, [
{ strategy: "isEmpty", errMsg: this.$t("LOGIN_LANG.inputYouPass") },
]);
if (dator2.getErrmsg()) {
this.$toast.text(dator2.getErrmsg());
return;
}

let postD = {
loginName: this.email,
password: this.passw,
};

this.$toast.loading();
this.loginFag = false;

this.GLOBAL_.ccRequest
.doAxios(this.CONFIG.USER.LOGIN, postD, "POST")
.then((res) => {

console.log("郵箱登录", res);
this.$toast.close();
this.saveLoginSession(res);
})
.catch((err) => {
this.loginFag = true;
let res = err.response;
this.$utils.showToast(
this.$t("LOGIN_LANG.loginErr") + res.data.message
);
});
},

onAuthentication() {
if (!this.ruleFlag) {
return this.$utils.showToast(this.$t("LOGIN_LANG.newUserSeeToast"));
}
let obj = {
client: "h5",
result: "0",
type: SERVER.APPID,
rawData: localStorage.getItem("thirdPartToken"),

};
let postD = {
data: JSON.stringify(obj),
};
this.$toast.loading();

this.GLOBAL_.ccRequest
.doAxios(this.CONFIG.USER.THIRDLOGIN, postD, "POST")
.then((res) => {

console.log("mylink登录", res);
this.$toast.close();



let obj = res.data.session;
obj["userInfo"] = res.data.userInfo;
loginFun.saveLoginSession(obj);

if (
res.data.userInfo.email == null &&
res.data.userInfo.phone == null
) {

this.bindThirdShow = true;
this.session = res.data.session;
this.userInfo = res.data.userInfo;
} else {
if (this.nextUrl) {
setTimeout(() => {
window.location.href = this.nextUrl;
}, 500);
} else {
setTimeout(() => {
this.$router.back()
}, 500);
}
}
})
.catch((err) => {
console.log("err", err);
this.loginFag = true;
let res = err.response;
if (res != "") {
this.$utils.showToast(
this.$t("LOGIN_LANG.loginErr") + res.data.message
);
}
});
},

onClosePop() {
if (this.nextUrl) {
setTimeout(() => {
window.location.href = this.nextUrl;
}, 500);
} else {
setTimeout(() => {
this.$router.back();
}, 500);
}
},

goRegister() {
if (!this.ruleFlag) {
return native.showToast(this.$t("LOGIN_LANG.newUserSeeToast"));
}
let obj = {
path: "register",
};
this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
},

gotoPage(page) {
let obj = {};
obj["path"] = this.UTILS.splitUrl(page);
obj.router = this.$router;
this.GLOBAL_.ccApp.openTo(obj);
},

selectPhone(idx) {
this.phoneArea = this.area[0][idx].value;
this.popupFlag = !this.popupFlag;
},
},
created() {},
mounted() {
this.nextUrl = this.$route.query.nextUrl || null;
this.showAuthView = this.authList.indexOf(SERVER.APPID) != -1;
},
beforeRouteEnter(to, from, next) {

next((vm) => {
vm.preRouter = from.path;
});
},
};



// WEBPACK FOOTER //
// ./src/pages/login/login.vue